/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SendPatientMessage from 'DesignSystem/SendPatientMessage/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/SendDocument/Content",
  onSubmit
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let patientPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.id',
})
let previewDocumentDocumentIdValueData = fromData.useDataValue({ viewPath,
context: 'preview_document',
path: 'document_id',
})
let previewDocumentDocumentIdSubmitData = fromData.useDataSubmit({ viewPath,
context: 'preview_document',
})
let authAccessTokenDataVaxiomUserIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.vaxiom_user_id',
})
let onSubmitPre = fromHelpers.useOnSubmitPre({
  children,
  viewPath,
  onSubmit
  
})
  return (<React.Fragment
>
<SendPatientMessage
  viewPath={`${viewPath}/SendPatientMessage`}
 data="patient.id"
 patientId={patientIdValueData}
 data="patient.person.id"
 personId={patientPersonIdValueData}
 data="preview_document.document_id"
 fileId={previewDocumentDocumentIdValueData}
 fileType="document"
 onSubmit={previewDocumentDocumentIdSubmitData}
 data="auth.access_token_data.vaxiom_user_id"
 userId={authAccessTokenDataVaxiomUserIdValueData}
 onSubmitPre={onSubmitPre}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}